import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Grid, TextField, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { search_filter_Stock } from '../../../services/stock_service';

const StockSearch = ({ categories, onSearch, loadStockData }) => {
    const [data, setData] = useState({
        prodCategory: "",
        desc: "",
    });

    const handleSearch = async () => {
        try {
            if (data.prodCategory || data.desc) { // at least one of them is full
                const response = await search_filter_Stock(data);
                onSearch(response);
            }
        } catch (error) {
            console.error("Erreur lors de la recherche:", error);
        }
    };

    const handleClear = () => {
        setData({ prodCategory: "", desc: "" }); 
        loadStockData(); 
    };

    useEffect(() => {
        handleSearch();
    }, [data]); 

    return (
        <div>
            <div className='search_filter_container'>
                <FormControl variant="standard" className="header_form">
                    <InputLabel id="category-label">Famille d'achat</InputLabel>
                    <Select
                        value={data.prodCategory}
                        onChange={(e) => setData({ ...data, prodCategory: e.target.value })}
                    >
                        <MenuItem value="">Toutes les familles d'achat</MenuItem>
                        {categories.map((categorie) => (
                            <MenuItem key={categorie.id_category} value={categorie.id_category}>
                                {categorie.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Grid container spacing={1} alignItems="center" className="search_bar">
                    <Grid item>
                        <SearchIcon   />
                    </Grid>
                    <Grid item>
                        <TextField variant='standard'
                            label="Chercher"
                            value={data.desc}
                            onChange={(e) => setData({ ...data, desc: e.target.value })}
                        />
                    </Grid>
                    <Grid item>
                        <IconButton onClick={handleClear}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default StockSearch;
